<template>
  <div
    class="right-menu-main"
    :style="{
      width: !showMe ? '0px' : `${widthSize}px`,
      minWidth: !showMe ? '0' : `${widthSize}px`,
      maxWidth: !showMe ? '0' : `${widthSize}px`,
      position: overlay ? 'absolute' : 'relative',
      padding: !showMe ? '0' : '5px',
      paddingLeft: !showMe ? '0' : '10px',
      transition: isTransition ? '0.3s' : '0s',
    }"
  >
    <!-- <div class="slider" @drag="sliderDrag" @dragend="sliderDragEnd"> -->
    <div class="slider" @mousedown="sliderMouseDown"></div>
    <div class="slider-bar"></div>
    <img
      v-if="showCloseButton"
      @click="closeClicked"
      class="close-button"
      src="https://dsmlib.logistics.systems/Icons/Cancel.png"
      alt=""
    />
    <slot></slot>
  </div>
</template>

<script>
/* eslint-disable */
export default {
  data: function () {
    return {
      widthSize: 0,
      showMe: true,

      isTransition: true,
      isDragging: false,
    };
  },
  props: {
    overlay: { type: Boolean, default: false },
    maxWidth: { type: Number, default: 500 },
    minWidth: { type: Number, default: 200 },
    defaultWidth: { type: Number, default: 420 },
    showMenu: { type: Boolean, default: true },
    showCloseButton: { type: Boolean, default: true },
    width: { type: Number, default: 0 },
  },
  methods: {
    sliderMouseDown: function (e) {
      if (e.button !== 0) {
        return;
      }

      e.preventDefault();

      this.isDragging = true;
      this.isTransition = false;

      const width = window.innerWidth - (e.clientX - 6);
      this.sliderBoundaries(width);

      this.$emit('resizeStart', this.widthSize);

      document.body.style.userSelect = 'none';
      document.addEventListener('mousemove', this.dragging);
      document.addEventListener('mouseup', this.sliderMouseUp, true);
    },
    sliderMouseUp: function (e) {
      if (!this.isDragging) {
        return;
      }

      this.isDragging = false;
      this.isTransition = true;

      if (e && e.clientX != null) {
        let width = window.innerWidth - (e.clientX - 6);
        this.sliderBoundaries(width);
      }

      document.body.style.userSelect = '';
      document.removeEventListener('mousemove', this.dragging);
      document.removeEventListener('mouseup', this.sliderMouseUp, true);

      this.$emit('resizeEnd', this.widthSize);
    },
    dragging: function (e) {
      if (!this.isDragging) {
        return;
      }
      let width = window.innerWidth - (e.clientX - 6);
      this.sliderBoundaries(width);

      this.$emit('resize', this.widthSize);
    },
    sliderBoundaries: function (width) {
      let value = Number(width);

      if (!isFinite(value)) {
        value = this.defaultWidth;
      }
      value = Math.max(10, Math.min(window.innerWidth - 10, value));

      if (this.minWidth !== -1) {
        value = Math.max(this.minWidth, value);
      }

      if (this.maxWidth !== -1) {
        value = Math.min(this.maxWidth, value);
      }

      this.widthSize = Math.round(value);
    },

    closeClicked: function () {
      this.showMe = false;
      this.$emit('update:showMenu', false);
    },

    setExternalWidth: function (width) {
      if (this.isDragging) {
        return;
      }

      this.sliderBoundaries(width || this.defaultWidth);
    },
  },

  mounted: function () {
    this.showMe = this.showMenu;
    this.setExternalWidth(this.width);
  },

  watch: {
    showMenu: function (val) {
      this.showMe = val;
    },

    width: function (val) {
      //needed because external width changes needs to affect component width
      this.setExternalWidth(val);
    },

    widthSize: function (val) {
      this.$emit('update:width', val);
    },
  },

  beforeDestroy: function () {
    document.removeEventListener('mousemove', this.dragging);
    document.removeEventListener('mouseup', this.sliderMouseUp, true);

    if (this.isDragging) {
      document.body.style.userSelect = '';
    }
  },
};
</script>

<style lang="scss" scoped>
@import '@/css/all.scss';

.right-menu-main {
  width: 420px;
  min-width: 420px;
  max-width: 420px;
  height: 100%;
  top: 0;
  right: 0;
  box-sizing: border-box;
  background-color: white;
  overflow-y: scroll;
  padding: 5px;
  padding-left: 10px;

  > .slider {
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
    padding: 0 5px;
    cursor: ew-resize;
    z-index: 5;

    &:active {
      cursor: grabbing;
      width: 100%;
      background-color: transparent;
      position: fixed;
      z-index: 999;
    }
  }

  > .slider-bar {
    position: absolute;
    height: 100%;
    width: 3px;
    left: 3px;
    top: 0;
    background-color: black;
    z-index: 3;
  }

  > .close-button {
    cursor: pointer;
    height: 23px;
    width: 23px;
    top: 5px;
    right: 5px;
    position: absolute;
    z-index: 998;
    margin: 3px;
    border-radius: 50%;
    background-color: white;
  }
}
</style>
